import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';

@Component({
  selector: 'app-coverage',
  templateUrl: './coverage.component.html',
  styleUrls: ['./coverage.component.scss']
})
export class CoverageComponent implements OnInit {

  constructor(private router: Router,
    private breadcrumbsService: BreadcrumbsService) {

  }

  ngOnInit() {
    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs: [
          { title: 'Administración', url: 'provision/management' },
          { title: 'Cobertura FTTH', url: 'provision/management/coverage' }
        ]
      });
  }

  public goToLoad(): void {
    this.router.navigate([`/provision/management/coverage/load`]);
  }

  public goToPriorities(): void {
    this.router.navigate([`/provision/management/coverage/priorities`]);
  }

  public goToDownload(): void {
    this.router.navigate([`/provision/management/coverage/download`]);
  }

}
